"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shadeClasses = void 0;
var _mui = require("@ori-ui/mui");
const shadeClasses = exports.shadeClasses = (0, _mui.generateUtilityClasses)('Shade', ['root', 'clearIcon']);
